import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  description?: string;
  fullWidth?: boolean;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  description,
  fullWidth = true,
  ...props
}: TextareaProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-531">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700" data-id="element-532">
          {label} {props.required && <span className="text-red-500" data-id="element-533">*</span>}
        </label>}
      <textarea id={inputId} className={`
          block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 
          px-4 py-2.5 text-sm transition-all duration-200
          placeholder:text-slate-400
          focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
          disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed
          ${error ? 'border-red-300 focus:border-red-500 bg-red-50/10' : 'hover:border-slate-300'}
          ${className}
        `} rows={4} {...props} data-id="element-534" />
      {description && !error && <p className="text-xs text-slate-500" data-id="element-535">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium animate-pulse" data-id="element-536">
          {error}
        </p>}
    </div>;
}